








import Vue from 'vue';

export default Vue.extend({
  props: {
    value: { default: false, type: Boolean },
    label: { default: undefined, type: String },
    disabled: { default: false, type: Boolean },
  },
  data: () => ({
    internalActive: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue: any) {
        (this as any).internalActive = newValue;
      },
    },
    internalActive() {
      this.$emit('input', this.internalActive);
      if (this.internalActive) {
        this.$emit('activate', this.internalActive);
      } else {
        this.$emit('deactivate', this.internalActive);
      }
    },
  },
});
